export function parseScore(score: string | number | undefined) {
  if (typeof score === 'undefined') return 0;

  const parsed = parseInt(`${score}`, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}
